import Vue from 'vue';

export class Hinova {

    static sendHbt(json){
        return Vue.http.post('configuracao-hinova/hbt', json);
    }

    static sendHbtAll(json){
        return Vue.http.post('configuracao-hinova/hbt/all', json);
    }

    static sendAngle(json){
        return Vue.http.post('configuracao-hinova/angle', json);
    }

    static sendAngleAll(json){
        return Vue.http.post('configuracao-hinova/angle/all', json);
    }

}
